import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';
import i18n from '@/i18n';

import type { BreadcrumbProps } from '@/dsComponents/breadcrumbs/types';

const routes: RouteRecordRaw[] = [
	{
		path: 'accueil',
		name: ROUTES.APP.HOME,
		component: () =>
			import(/* webpackChunkName: "home" */ './views/Dashboard.vue'),
		meta: {
			breadcrumbs: <BreadcrumbProps>{
				items: [
					{
						label: i18n.global.t('breadcrumbs.dashboard.root'),
						icon: 'home',
						link: { name: ROUTES.APP.HOME },
					},
				],
			},
		},
	},
];

export default routes;
